import React from 'react';
import { formatDateMMDDYYYY, formatDateWithTime } from 'services/dateService';

interface DateDisplayProps {
  isoString: string;
  showTime?: boolean;
}

const DateDisplay: React.FC<DateDisplayProps> = ({
  isoString,
  showTime = true,
}) => {
  const formatDate = (dateString: string): string => {
    if (!dateString) return '-';

    try {
      return showTime
        ? formatDateWithTime(dateString)
        : formatDateMMDDYYYY(dateString);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '-';
    }
  };

  return (
    <span>
      {formatDate(isoString)}
    </span>
  );
};

export default DateDisplay;